import * as React from 'react';
import { useSelector } from 'react-redux';

import {
  trackAgentFlatsLinkClick,
  trackAllFlatsLinkClick,
  trackOffersQuantityLinkClick,
  trackOpenFlat,
  trackRoomTypeLinkClick,
} from './tracking';
import { AgentsOffersRow } from '../../components/AgentsOffersRow';
import { OffersFooter } from '../../components/OffersFooter';
import { OffersList, OffersRow } from '../../components/OffersList';
import { selectDefaultProductsData } from '../../selectors/analytics';
import { getNewbuildingId } from '../../selectors/newbuilding';
import { getSelectedHouseId, getSelectedHouseOffers, isHouseNameVisible } from '../../selectors/offers';
import { BuilderOffersNotAvailable } from '../BuilderOffersNotAvailable';
import { OffersBannerContainer } from '../OffersBannerContainer';
import { trackServiceBannerClickChange } from '../ServiceBannerContainer/tracking';

export function OffersContainer() {
  const offers = useSelector(getSelectedHouseOffers);
  const displayHouseName = useSelector(isHouseNameVisible);
  const isHouseSelected = Boolean(useSelector(getSelectedHouseId));
  const product = useSelector(selectDefaultProductsData);

  const newbuildingId = useSelector(getNewbuildingId);

  const onSellersInfoClick = React.useCallback(() => {
    trackServiceBannerClickChange(newbuildingId);
  }, [newbuildingId]);

  const onOffersQuantityLinkClick = React.useCallback(
    (roomType: string) => {
      trackOffersQuantityLinkClick(product, roomType);
    },
    [product],
  );

  if (!offers) {
    return null;
  }

  const { fromAgentsPropsCountDisplay, fromAgentsPropsCountUrl, propsCountDisplay, propsCountUrl, fromDeveloperRooms } =
    offers;

  if (fromDeveloperRooms.length > 0) {
    return (
      <div data-testid="offers-stats">
        <OffersList>
          {fromDeveloperRooms.map(flatTypeBlock => (
            <OffersRow
              key={flatTypeBlock.roomTypeDisplay}
              {...flatTypeBlock}
              displayHouseName={displayHouseName}
              onRoomTypeLinkClick={trackRoomTypeLinkClick}
              onOffersQuantityLinkClick={onOffersQuantityLinkClick}
              onOfferLinkClick={trackOpenFlat}
            />
          ))}
        </OffersList>
        <OffersBannerContainer />
        <OffersFooter
          fromAgentsPropsCountDisplay={fromAgentsPropsCountDisplay}
          fromAgentsPropsCountUrl={fromAgentsPropsCountUrl}
          propsCountDisplay={propsCountDisplay}
          propsCountUrl={propsCountUrl}
          isHouseSelected={isHouseSelected}
          onAgentOffersLinkClick={trackAgentFlatsLinkClick}
          onAllOffersLinkClick={trackAllFlatsLinkClick}
          onSellersInfoClick={onSellersInfoClick}
        />
      </div>
    );
  }

  return (
    <>
      <BuilderOffersNotAvailable />
      <AgentsOffersRow
        fromAgentsPropsCountDisplay={fromAgentsPropsCountDisplay}
        fromAgentsPropsCountUrl={fromAgentsPropsCountUrl}
      />
    </>
  );
}
